// extracted by mini-css-extract-plugin
export default {"heart":"Heart-module__heart___AKeGn"};